const encodeKebabCase = (str) => {
  if (!str) {
    return '';
  }
  return str.toLowerCase().replace(/\s/g, '-');
};

const formatInDollars = num => (
  `$${num.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
);

const capitalizeFirstLetter = str => (
  str.charAt(0).toUpperCase() + str.slice(1)
);

const isJson = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export {
  capitalizeFirstLetter,
  encodeKebabCase,
  formatInDollars,
  isJson,
};
